export const ICON_DEFAULT = '#27272A';
export const ICON_ONDARK = '#FAFAFA';
export const ICON_SECONDARY = '#71717A';
export const ACCENT = '#FE9867';
